import React from 'react';
import {
  makeStyles,
  createStyles,
} from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from '../../../helpers';

const statusColors = {
  submitted: '#39843b',
  late: '#ffb300',
  not_submitted: '#f44336',
  completed: '#8bc34a',
};

const useStyles = makeStyles(theme => createStyles({
  root: {
    display: 'inline-block',
    borderRadius: 20,
    backgroundColor: '#9e9e9e',
    color: '#ffffff',
    padding: '2px 20px',
    verticalAlign: 'middle',
  },
}));

export default function HomeworkGroupHeaderBadge(props) {
  const classes = useStyles();
  const {
    t,
  } = useTranslation(undefined, { useSuspense: false });

  const status = props.status;
  const heading = status === 'todo'
    ? t('to do')
    : (status === 'late'
      ? t('submitted late')
      : t(status.replace('_', ' '))
    );
  let headingBadgeColor = typeof statusColors[status] !== 'undefined'
    ? statusColors[status]
    : '#9e9e9e';

  return (
    <div
      className={`homework-group-header-badge ${classes.root}`}
      style={{ backgroundColor: headingBadgeColor }}
    >
      {capitalizeFirstLetter(heading)}
    </div>
  );
}
